import Vue from 'vue';
import Router from 'vue-router';

import Index from './views/index.vue';
import AboutUs from './views/aboutUs.vue';
import Announcement from './views/announcement.vue';
import AnnouncementList from './views/announcementList.vue';
import ContactUs from './views/contactUs.vue';
import JoinUs from './views/joinUs.vue';
import SceneService from './views/sceneService.vue';
import JoinUsDetail from './views/joinUsDetail.vue';
import JoinUsMain from './views/joinUsMain.vue';
import Financing from './views/financing.vue'
import EightFestival from './views/eightFestival.vue'
import OrderInstallment from './views/orderInstallment.vue'
import Test from './views/test.vue'
import ServiceProvider from './views/serviceProvider.vue'
import WordExtract from './views/wordExtract.vue'
export default new Router({
  routes: [
    {
      name: 'index',
      path: '/index',
      component: Index
    },
    {
      name: 'index2',
      path: '/',
      redirect: '/index'
    },
    {
      name: 'aboutUs',
      path: '/aboutUs',
      component: AboutUs
    },
    {
      name: 'announcement',
      path: '/announcement',
      component: Announcement
    },
    {
      name: 'announcementList',
      path: '/announcementList',
      component: AnnouncementList
    },
    {
      name: 'contactUs',
      path: '/contactUs',
      component: ContactUs
    },
    {
      name: 'joinUs',
      path: '/joinUs',
      component: JoinUs
    },
    {
      name: 'joinUsDetail',
      path: '/joinUsDetail',
      component: JoinUsDetail
    },
    {
      name: 'joinUsMain',
      path: '/joinUsMain',
      component: JoinUsMain
    },
    {
      name: 'sceneService',
      path: '/sceneService',
      component: SceneService
    },
    {
      name: 'financing',
      path: '/financing',
      component: Financing
    },
    {
      name: 'eight-festival',
      path: '/eightFestival',
      component: EightFestival
    },
    {
      name: 'order-installment',
      path: '/orderInstallment',
      component: OrderInstallment
    },
    {
      name: 'order-test',
      path: '/orderInstallment/test',
      component: Test
    },
    {
      name: 'service-provider',
      path: '/service/provider',
      component: ServiceProvider
    },
    {
      name: 'word-extract',
      path: '/wordExtract',
      component: WordExtract
    }
  ]
});



// WEBPACK FOOTER //
// ./app/resource/page/index/router.js